<script setup>
import ComponentSettingsForm from './ComponentSettingsForm'
import ComponentSettingsDuplicateFormItem from './ComponentSettingsDuplicateFormItem'
import ComponentSettingsDeleteFormItem from './ComponentSettingsDeleteFormItem'
</script>

<template>
    <div class="container pt-5 pb-5">
        <ComponentSettingsForm/>

        <div class="list-group">
            <div class="list-group-item">
                <ComponentSettingsDuplicateFormItem/>
            </div>
        </div>

        <h3>Danger zone</h3>

        <div class="list-group">
            <div class="list-group-item danger-list-group-item">
                <ComponentSettingsDeleteFormItem/>
            </div>
        </div>
    </div>
</template>

<style scoped>
h3 {
    padding: 30px 15px 15px;
}

.danger-list-group-item {
    border-color: #ebccd1;
}
</style>